import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

interface VideosInterviews {
    title: string;
    url: string;
    year: number;
  }
const videoInterviews = {
    title: "",
    url: "",
    year: 0,
  };
  

const initialState: VideosInterviews = videoInterviews;

const videoInterviewsSlice = createSlice({
  name: "videointerviews",
  initialState,
  reducers: {
    setVidoesInterviews:(state , action : PayloadAction<VideosInterviews>) =>
      state = {...action.payload}
  },
});
const videoInterviewsAction = videoInterviewsSlice.actions
const persistConfig = {
    key: "uxpin-videos--root-state",
    storage,
  };

const videoInterviewsReducer = persistReducer(persistConfig,videoInterviewsSlice.reducer)
export {videoInterviewsAction, videoInterviewsReducer}